/** Drop a leftover dialog lock so the menu and page can scroll again. */
export function releaseModalScrollLock() {
  window.setTimeout(() => {
    const dialogStillOpen = document.querySelector(
      '.MuiDialog-root:not([aria-hidden="true"])',
    );
    if (dialogStillOpen) return;

    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
    document.getElementById('root')?.removeAttribute('aria-hidden');

    document.querySelectorAll<HTMLElement>('.wf-shell, .wf-main, .wf-content').forEach((el) => {
      el.style.removeProperty('overflow');
      el.style.removeProperty('padding-right');
    });

    document.querySelectorAll('body > .MuiModal-root').forEach((node) => {
      if (node.getAttribute('aria-hidden') === 'true') node.remove();
    });
  }, 0);
}
